import LinkButton from "../buttons/button/LinkButton";
import { BUTTON_TYPES } from "../buttons/button/ButtonTypes";
import { generateOneLinkURL } from "../../utils/oneLinkGenerator";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { useProduct } from "../../context/product/ProductContext";
import styles from "./DownloadAppButton.scss";

const DownloadAppButton = () => {
  const { getTranslation, isMobile, webContext, isMixAndMatch } =
    useRuntimeConstants();
  const { product } = useProduct();

  const buttonText = getTranslation("download_the_app_cta_title");
  const generatedUrl = generateOneLinkURL(webContext, product);

  return (
    <LinkButton
      href={
        isMobile
          ? generatedUrl
          : `/discover/our-apps/?campaign=eap-app-adoption&deepLink=asos://prd%3Fiid=${product.id}&media=button`
      }
      type={
        isMixAndMatch ? BUTTON_TYPES.loyaltyFullWidth : BUTTON_TYPES.loyalty
      }
      ariaLabel={buttonText}
    >
      <div className={styles.buttonText}>{buttonText}</div>
    </LinkButton>
  );
};

export default DownloadAppButton;
